import { Directive, ElementRef, input, OnDestroy, OnInit, inject } from '@angular/core';
import { ComponentVisibilityService } from '../pages/component-visibility.service';

@Directive({
  selector: '[pvmoComponentTracker]'
})
export class ComponentTrackerDirective implements OnInit, OnDestroy {
  private readonly elementRef = inject(ElementRef);
  private readonly visibilityService = inject(ComponentVisibilityService);

  id = input.required<string>();

  ngOnInit(): void {
    const componentInfo = {
      id: this.id(),
      element: this.elementRef.nativeElement
    };
    const currentComponents = this.visibilityService['componentsSignal']();
    this.visibilityService.registerComponents([...currentComponents, componentInfo]);
  }

  ngOnDestroy(): void {
    this.visibilityService.unregisterComponents();
  }
}
